var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main-background'),_c('main-menu'),_c('main-social-links'),_c('main-page',[_c('router-view')],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }